/// <amd-module name="Likes/RestClient/Social" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   social\client\webapi\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Social from "Likes/Contracts/Social";
import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface ISocialRestClient extends IVssRestClient {
    /**
     * @param socialEngagementCreateParameter - 
     */
    createSocialEngagement(socialEngagementCreateParameter: Social.SocialEngagementCreateParameter): Promise<Social.SocialEngagementRecord>;
    /**
     * @param artifactType - 
     * @param artifactId - 
     * @param engagementType - 
     * @param artifactScopeType - 
     * @param artifactScopeId - 
     */
    deleteSocialEngagement(artifactType: string, artifactId: string, engagementType: Social.SocialEngagementType, artifactScopeType: string, artifactScopeId?: string): Promise<Social.SocialEngagementRecord>;
    /**
     * @param artifactType - 
     * @param artifactId - 
     * @param engagementType - 
     * @param artifactScopeType - 
     * @param artifactScopeId - 
     */
    getSocialEngagement(artifactType: string, artifactId: string, engagementType: Social.SocialEngagementType, artifactScopeType: string, artifactScopeId?: string): Promise<Social.SocialEngagementRecord>;
    /**
     * @param artifactType - 
     * @param artifactId - 
     * @param engagementType - 
     * @param artifactScopeType - 
     * @param artifactScopeId - 
     */
    getSocialEngagementAggregateMetric(artifactType: string, artifactId: string, engagementType: Social.SocialEngagementType, artifactScopeType: string, artifactScopeId?: string): Promise<Social.SocialEngagementAggregateMetric>;
    /**
     */
    getSocialEngagementProviders(): Promise<{ key: Social.SocialEngagementType; value: string }[]>;
    /**
     * @param artifactType - 
     * @param artifactId - 
     * @param engagementType - 
     * @param artifactScopeType - 
     * @param artifactScopeId - 
     * @param top - 
     * @param skip - 
     */
    getEngagedUsers(artifactType: string, artifactId: string, engagementType: Social.SocialEngagementType, artifactScopeType: string, artifactScopeId?: string, top?: number, skip?: number): Promise<VS_Services.IdentityRef[]>;
}

class SocialRestClient extends RestClientBase implements ISocialRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param socialEngagementCreateParameter - 
     */
    public async createSocialEngagement(
        socialEngagementCreateParameter: Social.SocialEngagementCreateParameter
        ): Promise<Social.SocialEngagementRecord> {

        return this.beginRequest<Social.SocialEngagementRecord>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/Social/SocialEngagement",
            body: socialEngagementCreateParameter
        });
    }

    /**
     * @param artifactType - 
     * @param artifactId - 
     * @param engagementType - 
     * @param artifactScopeType - 
     * @param artifactScopeId - 
     */
    public async deleteSocialEngagement(
        artifactType: string,
        artifactId: string,
        engagementType: Social.SocialEngagementType,
        artifactScopeType: string,
        artifactScopeId?: string
        ): Promise<Social.SocialEngagementRecord> {

        const queryValues: any = {
            artifactType: artifactType,
            artifactId: artifactId,
            engagementType: engagementType,
            artifactScopeType: artifactScopeType,
            artifactScopeId: artifactScopeId
        };

        return this.beginRequest<Social.SocialEngagementRecord>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Social/SocialEngagement",
            queryParams: queryValues
        });
    }

    /**
     * @param artifactType - 
     * @param artifactId - 
     * @param engagementType - 
     * @param artifactScopeType - 
     * @param artifactScopeId - 
     */
    public async getSocialEngagement(
        artifactType: string,
        artifactId: string,
        engagementType: Social.SocialEngagementType,
        artifactScopeType: string,
        artifactScopeId?: string
        ): Promise<Social.SocialEngagementRecord> {

        const queryValues: any = {
            artifactType: artifactType,
            artifactId: artifactId,
            engagementType: engagementType,
            artifactScopeType: artifactScopeType,
            artifactScopeId: artifactScopeId
        };

        return this.beginRequest<Social.SocialEngagementRecord>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Social/SocialEngagement",
            queryParams: queryValues
        });
    }

    /**
     * @param artifactType - 
     * @param artifactId - 
     * @param engagementType - 
     * @param artifactScopeType - 
     * @param artifactScopeId - 
     */
    public async getSocialEngagementAggregateMetric(
        artifactType: string,
        artifactId: string,
        engagementType: Social.SocialEngagementType,
        artifactScopeType: string,
        artifactScopeId?: string
        ): Promise<Social.SocialEngagementAggregateMetric> {

        const queryValues: any = {
            artifactType: artifactType,
            artifactId: artifactId,
            engagementType: engagementType,
            artifactScopeType: artifactScopeType,
            artifactScopeId: artifactScopeId
        };

        return this.beginRequest<Social.SocialEngagementAggregateMetric>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Social/SocialEngagementAggregateMetric",
            queryParams: queryValues
        });
    }

    /**
     */
    public async getSocialEngagementProviders(
        ): Promise<{ key: Social.SocialEngagementType; value: string }[]> {

        return this.beginRequest<{ key: Social.SocialEngagementType; value: string }[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Social/SocialEngagementProviders"
        });
    }

    /**
     * @param artifactType - 
     * @param artifactId - 
     * @param engagementType - 
     * @param artifactScopeType - 
     * @param artifactScopeId - 
     * @param top - 
     * @param skip - 
     */
    public async getEngagedUsers(
        artifactType: string,
        artifactId: string,
        engagementType: Social.SocialEngagementType,
        artifactScopeType: string,
        artifactScopeId?: string,
        top?: number,
        skip?: number
        ): Promise<VS_Services.IdentityRef[]> {

        const queryValues: any = {
            artifactType: artifactType,
            artifactId: artifactId,
            engagementType: engagementType,
            artifactScopeType: artifactScopeType,
            artifactScopeId: artifactScopeId,
            top: top,
            skip: skip
        };

        return this.beginRequest<VS_Services.IdentityRef[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Social/SocialEngagementUsers",
            queryParams: queryValues
        });
    }

}

export const SocialClientName = "ISocialRestClient";

export function getSocialClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ISocialRestClient {
    return pageContext.getRestClient<ISocialRestClient>(SocialClientName, options);
}

RestClients.add(SocialClientName, { 
    factory: SocialRestClient
});
